import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ligipaasetavus = _resolveComponent("Ligipaasetavus")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_Ligipaasetavus)
    ]),
    _: 1
  }))
}